import { useState, useEffect, useContext, useCallback } from 'react'
import { UserContext } from '../../contexts/userProvider';
import { useNavigate, Outlet } from 'react-router-dom';
import SideBar from './SideBar'
import Header from './Header'
import TutorialProvider from '../Tutorial/TutorialProvider';


const Home = () => {
  const { user } = useContext(UserContext);
  const [sideBar, setSideBar] = useState(true)
  const [selectedItem, setSelectedItem] = useState('Dashboard');
  const navigate = useNavigate();
  // const components = ['Dashboard', 'Clientes', 'Anexos', 'Fornecedores', 'Linhas','Entrada','Patrimônio', 'Serviços', 'Relatórios'];
  const [components, setComponents] = useState([])

  useEffect(() => {
    // Preserva a rota atual no refresh; so cai no padrao quando entra em /home "seco".
    const sub = decodeURIComponent(window.location.pathname.replace(/^\/home\/?/, ''));
    if (!sub) {
      navigate(`/home/${selectedItem.toLowerCase()}`);
    } else {
      setSelectedItem(sub.charAt(0).toUpperCase() + sub.slice(1));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else {
      if (user?.nivel === '1' || user?.nivel === '2' || !user?.nivel) {
        const base = [
          { name: 'Dashboard' },
          { name: 'Clientes' },
          { name: 'Secretarias' },
          { name: 'Anexos' },
          { name: 'Linhas' },
          { name: 'Patrimônio' },
          { name: 'Relatórios' }
        ];
        if (user?.nivel === '2') base.push({ name: 'Usuarios' }); // Faturamento no menu é só admin (15/set)
        base.push({ name: 'Tutoriais' });
        setComponents(base);
      } else if (user?.nivel === '3') {
        setComponents([
          { name: 'Dashboard' },
          { name: 'Clientes' },
          { name: 'Secretarias' },
          { name: 'Usuarios' },
          { name: 'Anexos' },
          { name: 'Fornecedores' },
          { name: 'Linhas' },
          { name: 'Entrada' },
          { name: 'Patrimônio' },
          { name: 'Serviços' },
          { name: 'Relatórios' },
          {
            name: 'Faturador',
            isGroup: true,
            links: [
              { name: 'Relatórios', link: 'faturador/relatorios' },
              // { name: 'Faturar Equipamentos', link: 'faturador/equipamentos' },
              { name: 'SaperX', link: 'faturador/saperx' },
              { name: 'Pendências de cadastro', link: 'faturador/pendencias' }
            ]
          },
          { name: 'Faturamento' },
          { name: 'Vox Softwares' },
          { name: 'Chaves de API' },
          { name: 'Auditoria' },
          { name: 'Tutoriais' }
        ]);
      }
    }
  }, [user]);
  

  const handleSideBar = () => {
    setSideBar(!sideBar)
  }

  const handleItemClick = (item) => {
    setSelectedItem(item);
    navigate(`/home/${item.toLowerCase()}`);
  };

  const voltarAosTutoriais = useCallback(() => {
    setSelectedItem('Tutoriais');
    navigate('/home/tutoriais');
  }, [navigate]);

  const abrirMenuLateral = useCallback(() => setSideBar(true), []);

  return (
    <TutorialProvider voltarAosTutoriais={voltarAosTutoriais} abrirMenuLateral={abrirMenuLateral}>
      <div className='h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 flex flex-col lg:flex-row transition-colors duration-300 overflow-hidden'>
        <SideBar handleSideBar={handleSideBar} sideBar={sideBar} components={components} setSelectedItem={setSelectedItem} selectedItem={selectedItem} handleItemClick={handleItemClick} />
        <div className="flex-1 flex flex-col overflow-hidden min-h-0">
          <Header />
          <main className="flex-1 overflow-y-auto p-2 sm:p-4 md:p-6 lg:p-8 xl:p-10">
            <div className="w-full max-w-full">
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </TutorialProvider>
  )
}

export default Home
